<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-slider
          v-model="year"
          thumb-label="always"
          :min="startYear"
          :max="endYear"
          :step="1"
          class="mt-10 mb-n6"
          @update:modelValue="drag"
        >
        </v-slider>
      </v-col>
      <v-col cols="12">
        <v-btn
          variant="text"
          icon="$backwardFastSolid"
          size="small"
          @click="rewind(false)"
        ></v-btn>
        <v-btn
          variant="text"
          icon="$backwardStepSolid"
          size="small"
          @click="stepBackwardBtn"
        ></v-btn>
        <v-btn
          variant="text"
          :icon="playing ? '$pauseSolid' : '$playSolid'"
          size="x-large"
          @click="togglePlayback"
        ></v-btn>
        <v-btn
          variant="text"
          icon="$forwardStepSolid"
          size="small"
          @click="stepForwardBtn"
        ></v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script setup>
const { startYear, commitmentYear, endYear } = usePathwaysConfig();

const emit = defineEmits(["update:year"]);

const year = ref(commitmentYear);
const playing = ref(false);
const playbackSpeed = 500; // how many milliseconds to wait between steps during playback

const stepForward = () => {
  if (year.value < endYear) {
    year.value = year.value + 1 || endYear;
    emit("update:year", year.value);
  }
};

const stepForwardBtn = () => {
  playing.value = false;
  stepForward();
};

const stepBackward = () => {
  year.value = year.value - 1 || startYear;
  emit("update:year", year.value);
};

const stepBackwardBtn = () => {
  playing.value = false;
  stepBackward();
};

const rewind = (keepPlaying = false) => {
  if (keepPlaying === false) {
    playing.value = false;
  }
  year.value = startYear;
  emit("update:year", year.value);
};

const drag = () => {
  playing.value = false;
  emit("update:year", year.value);
};

const togglePlayback = () => {
  if (!playing.value) {
    playing.value = true;
    if (year.value === endYear) {
      // rewind if pressing play with timeline already at end
      rewind(true);
    }
    let currentYear = year.value;

    const nextStep = () => {
      if (playing.value && currentYear < endYear) {
        stepForward();
        currentYear++;
        if (playing.value) {
          setTimeout(nextStep, playbackSpeed); // Call nextStep again after 500ms
        }
      } else {
        playing.value = false;
      }
    };

    nextStep(); // Call nextStep initially
  } else {
    playing.value = false;
  }
};
</script>
